class App {
    constructor() {
        $("#selectLanguage").on("change", "select", function () {
            $(this).parent().submit();
        });
        // enable bootstrap tooltip
        $("[data-toggle='tooltip']").tooltip();
        try {
            this.createHandleBarHelpers();
        }
        catch (e) {
            console.log(e);
        }
    }
    /**
     * Change delphi button to loading delphi button
     *
     * @param formIdentifier class or jquery identifier of form
     */
    loadingStateForDelphiBtn(formIdentifier) {
        if (formIdentifier.indexOf(".") !== 0 && formIdentifier.indexOf("#") !== 0) {
            throw new Error("Please provide a string statring with '.' or '#'");
        }
        // show loading on submit
        $(document).on("submit", formIdentifier, function () {
            $(this).find(":submit").addClass("btn-delphi-loading");
        });
    }
    /**
     * swipe active li on click for the sub nav bar
     *
     * @param subNavBarIdentifier class or id identifier for sub nav bar
     */
    SwipeActiveInSubNavBar(subNavBarIdentifier) {
        if (subNavBarIdentifier.indexOf(".") !== 0 && subNavBarIdentifier.indexOf("#") !== 0) {
            throw new Error("Please provide a string statring with '.' or '#'");
        }
        $(subNavBarIdentifier).find(".active").removeClass("active");
        $(subNavBarIdentifier).addClass("active");
    }
    /**
     * Create some handlebarjs helpers
     */
    createHandleBarHelpers() {
        //if with condition helper
        Handlebars.registerHelper("ifCond", function (v1, v2, options) {
            if (v1 == v2) {
                return options.fn(this);
            }
            else {
                return options.inverse(this);
            }
        });
        //handlebars date helper
        Handlebars.registerHelper("date", function (object) {
            var data = Handlebars.escapeExpression(object);
            return new Handlebars.SafeString(new Date(Date.parse(object)).toLocaleDateString());
        });
        //create html order pagination helper
        Handlebars.registerHelper("orderPagination", function (n, selected, block) {
            var accum = "";
            var html = "";
            for (var i = 1; i <= n; ++i) {
                var li = undefined;
                if (i == selected) {
                    li = new Handlebars.SafeString('<li><a href="#" onclick="orders.getOrderByPage(event,' + i + ')" class="selected">' + i + '</a></li >');
                }
                else {
                    li = new Handlebars.SafeString('<li><a href="#" onclick="orders.getOrderByPage(event,' + i + ')" >' + i + '</a></li >');
                }
                html += li;
            }
            return new Handlebars.SafeString(html);
        });
        Handlebars.registerHelper("json", function (context) {
            return JSON.stringify(context).replace(/"/g, '&quot;');
        });
    }
    /**
     * Return class of http status content to display
     * @param status
     */
    StatusHandler(status) {
        switch (status) {
            case 204:
                return ".delphi-no-content";
            case 400:
                return ".delphi-warning";
            case 500:
                return ".delphi-error";
            case 201:
                return ".delphi-ok";
            default:
                return "";
        }
    }
    /**
     * Parse get data as object
     */
    parseQueryString() {
        var qs = window.location.search;
        qs = qs.split('+').join(' ');
        var params = {}, tokens, re = /[?&]?([^=]+)=([^&]*)/g;
        while (tokens = re.exec(qs)) {
            params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
        }
        return params;
    }
    ;
}
let app = new App();

//# sourceMappingURL=app.js.map
